// @ts-check
// Etapas "em atendimento" (K37) que a tela de Privacidade grava: só as que o funil ainda mostra como caixa. Uma etapa
// renomeada ou excluída que ficou na lista lida não pode voltar ao salvar (o servidor recusa etapa que não existe).

/**
 * @param {readonly string[]} stages etapas marcadas na tela
 * @param {ReadonlyArray<{ value: string }>} stageOptions etapas do funil que viram caixa
 * @returns {string[]}
 */
export function serviceStagesToSave(stages, stageOptions) {
  const available = new Set(stageOptions.map((option) => option.value));
  return [...new Set(stages)].filter((stage) => available.has(stage));
}
